import { useEffect, useState } from "react";

/** Props Interface */
export interface UseIsHoveredProps {
	/** Reference */
	ref: React.RefObject<HTMLElement | null>;
}

export function useIsHovered({ ref }: UseIsHoveredProps) {
	/** State */
	const [isHovered, setIsHovered] = useState<boolean>(false);

	/** Hooks */
	useEffect(() => {
		const node = ref.current;
		if (!node) return;

		function handleMouseEnter() {
			setIsHovered(true);
		}

		function handleMouseLeave() {
			setIsHovered(false);
		}

		node.addEventListener("mouseenter", handleMouseEnter);
		node.addEventListener("mouseleave", handleMouseLeave);

		return () => {
			node.removeEventListener("mouseenter", handleMouseEnter);
			node.removeEventListener("mouseleave", handleMouseLeave);
		};
	}, []);

	return isHovered;
}
